export default "__VITE_ASSET__DXy39jSr__"